import * as React from 'react'
import MUIDivider from '@mui/material/Divider'

const Divider = (props) => <MUIDivider {...props} />

export default Divider
